export const UNSUBSCRIBE_REASONS = {
  TOO_MANY_EMAILS: 'TOO_MANY_EMAILS',
  NOT_RELEVANT: 'NOT_RELEVANT',
  WRONG_PERSON: 'WRONG_PERSON',
  OTHER: 'OTHER',
} as const;

export type UnsubscribeReason = (typeof UNSUBSCRIBE_REASONS)[keyof typeof UNSUBSCRIBE_REASONS];

